export enum PostSpring2023ExamCode {
    GHDP = 'GHDP',
    GHVRUS = 'GHVR-US',
    GHRM = 'GHRM',
    REMOVED = 'REMOVED',
}

export type PostSpring2023ExamCodeType =
    | PostSpring2023ExamCode.GHDP
    | PostSpring2023ExamCode.GHRM
    | PostSpring2023ExamCode.GHVRUS

export enum PreSpring2023ExamCode {
    GHDP = 'GHDP',
    GHFVUS = 'GHFV-US',
    GHSPC = 'GHSPC',
    NEW = 'NEW', // parts of PostSpring2023 syllabus that was not covered PreSpring2023
}

export enum SourceType {
    Textbook = 'Textbook',
    Asop = 'ASOP',
    Website = 'Website',
    StudyNote = 'Study Note',
}

export interface ExamChangeGuidePageProps {
    isLoggedIn: boolean
}
